import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom/dist";
import AddBrand from "../../core/modals/inventory/addbrand";
import EditBrand from "../../core/modals/inventory/editbrand";
import Table from "../../core/pagination/datatable";
import { PlusCircle } from "feather-icons-react/build/IconComponents";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  DeleteRequest,
  GetRequest,
  PatchRequest,
  PostRequest,
} from "../../Api/ApiFunctions";
import { ApiUrl, ConfUrl } from "../../Api/EndPoints";
import {
  DeletConfirmation,
  showDeleteConfirmationAlert,
} from "../MyComponents/SwalAlerts";
import { all_routes } from "../../Router/all_routes";
import { PermissionHandler } from "../MyComponents/PermissionHandler";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
// import { transformObject } from "./constants";
import TextArea from "./Components/TextArea";

const Career = () => {
  const GlobalState = useSelector((state) => state.access_control);
  const [dataSource, setDataSource] = useState([]);
  const [Selecteddata, setSelecteddata] = useState({});
  const navigate = useNavigate();
  const {
    // register,
    handleSubmit,
    setValue,
    // getValues,
    control,
    // reset,
    formState: { isSubmitting },
  } = useForm();

  const fetchData = async () => {
    const res = await GetRequest(ApiUrl.career);
    if (res) {
      setDataSource(res);
    }
    const res1 = await GetRequest(`${ApiUrl.configuration}${ConfUrl.career}`);
    if (res1) {
      setValue("subHeading", res1?.value?.subHeading);
    }
  };
  const onSubmit = async (data) => {
    const resp = await PatchRequest(
      `${ApiUrl.configuration}${ConfUrl.career}`,
      data
    );

    if (resp) {
      console.log("samle");

      navigate(all_routes.jobapplication);
    }
  };

  const RemoveData = async (id) => {
    const res = await DeleteRequest(`${ApiUrl.career}/${id}`);
    if (res) {
      DeletConfirmation();
      fetchData();
    }
  };
  const setStatusChange = async (id) => {
    const res = await PostRequest(`${ApiUrl.career}/status/${id}`);
    if (res) {
      fetchData();
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const renderRefreshTooltip = (props, Data) => (
    <Tooltip id="refresh-tooltip" {...props}>
      {Data}
    </Tooltip>
  );

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      sorter: (a, b) => a.title.length - b.title.length,
    },

    {
      title: "Location",
      dataIndex: "location",
      sorter: (a, b) => a.location.length - b.location.length,
    },
    {
      title: "Type",
      dataIndex: "type",
      sorter: (a, b) => a.type.length - b.type.length,
    },
    {
      title: "Date Added",
      dataIndex: "dateAdded",
      sorter: (a, b) => a.dateAdded.length - b.dateAdded.length,
    },
    {
      title: "Status",
      dataIndex: "isActive",
      render: (isActive) =>
        isActive ? (
          <span className="badge badge-linesuccess">Active</span>
        ) : (
          <span className="badge badge-linedanger">InActive</span>
        ),
      sorter: (a, b) => a.isActive.length - b.isActive.length,
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      align: "center",
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            {PermissionHandler(GlobalState, "career", "UPDATE") && (
              <>
                <OverlayTrigger
                  placement="top"
                  overlay={(d) =>
                    renderRefreshTooltip(
                      d,
                      `${record.isActive ? "DeActivate" : "Activate"}`
                    )
                  }
                >
                  <a
                    className="me-2 p-2"
                    onClick={() => setStatusChange(record.id)}
                  >
                    <i
                      data-feather="edit"
                      className={`${
                        record.isActive ? "feather-pause" : "feather-play"
                      }`}
                    ></i>
                  </a>
                </OverlayTrigger>
                <OverlayTrigger
                  placement="top"
                  overlay={(d) => renderRefreshTooltip(d, "Edit")}
                >
                  <Link
                    className="me-2 p-2"
                    to={`${all_routes.editcareer}?id=${record.id}`}
                    onClick={() => setSelecteddata(record)}
                  >
                    <i data-feather="edit" className="feather-edit"></i>
                  </Link>
                </OverlayTrigger>
              </>
            )}
            <OverlayTrigger
              placement="top"
              overlay={(d) => renderRefreshTooltip(d, "Delete")}
            >
              {PermissionHandler(GlobalState, "career", "DELETE") && (
                <Link
                  className="confirm-text p-2"
                  to="#"
                  onClick={() =>
                    showDeleteConfirmationAlert(record.id, RemoveData)
                  }
                >
                  <i data-feather="trash-2" className="feather-trash-2"></i>
                </Link>
              )}
            </OverlayTrigger>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Career</h4>
                <h6>Manage your Careers</h6>
              </div>
            </div>
          </div>
          {/* /product list */}
          <div className="card">
            <div className="card-body add-product">
              <div className="row">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="col-12">
                    <label className="form-label">Sub Heading</label>
                    <TextArea
                      control={control}
                      id="subHeading"
                      placeholder="Section content"
                    />
                  </div>
                  <div className="col-lg-12">
                    <div className="btn-addproduct mb-4">
                      <button
                        type="submit"
                        className="btn btn-submit"
                        disabled={isSubmitting}
                        // onClick={() => }
                      >
                        {isSubmitting ? (
                          <span className="spinner-border spinner-border-sm"></span>
                        ) : (
                          "Save"
                        )}
                      </button>
                    </div>
                  </div>
                </form>
                <hr />

                <h4>
                  <u>Careers</u>
                </h4>
                <div className="d-flex justify-content-end">
                  <div className="btn btn-primary ">
                    <Link to={all_routes.addcareer} className="text-white">
                      <PlusCircle className="me-2" />
                      Add New Career
                    </Link>
                  </div>
                </div>

                <div className="table-responsive">
                  <Table columns={columns} dataSource={dataSource} />
                </div>
              </div>
            </div>
            {/* /product list */}
          </div>
        </div>
      </div>
      <AddBrand />
      <EditBrand editData={Selecteddata} />
    </div>
  );
};

export default Career;
